import { ReactNode } from 'react';
import { Container } from '@optimus-web/core';
import { SMALL_CONTAINER_WIDTH } from '../constants';

interface SmallContainerProps {
    children: ReactNode;
}

export const SmallContainer: React.FC<SmallContainerProps> = ({ children }) => (
    <Container maxWidth={`${SMALL_CONTAINER_WIDTH}px`}>{children}</Container>
);
